import { RouterView, type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  formSubmissions: "FormSubmission.FormSubmissions",
  list: "FormSubmission.FormSubmissionList",
  base: "FormSubmission.FormSubmissionBase",
  view: "FormSubmission.FormSubmissionView",
  assignFormSubmission: "FormSubmission.AssignFormSubmission",
  wellDimensions: "FormSubmission.FormSubmissionWellDimensions",
  injections: "FormSubmission.FormSubmissionInjections",
};

export { names as formSubmissionRouteNames };

const formSubmissionRoutes: RouterOptions["routes"] = [
  {
    path: "/formSubmission",
    name: names.formSubmissions,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: { title: "Form Submissions" },
        component: () => import("@/views/formSubmission/FormSubmissionList.vue"),
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/formSubmission/FormSubmissionBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Form Submission View" },
            component: () => import("@/views/formSubmission/FormSubmissionView.vue"),
          },
          {
            path: "assign",
            name: names.assignFormSubmission,
            meta: { title: "Assign Application", isForm: true },
            component: () => import("@/views/formSubmission/AssignFormSubmission.vue"),
          },
          {
            path: "injections",
            name: names.injections,
            meta: { title: "Form Submission Injection" },
            component: () => import("@/views/formSubmission/InjectionsChildList.vue"),
          },
          {
            path: "wells",
            name: names.wellDimensions,
            meta: { title: "Form Submission Well Dimensions" },
            component: () => import("@/views/formSubmission/FormSubmissionWellDimensions.vue"),
          },
        ],
      },
    ],
  },
];
export default formSubmissionRoutes;
